// "Tens o código UPC deste lançamento?" Sim → the barcode it already has;
// Não → Izenu provides one. Same question as the web app's studio.

// UPC-A has 12 digits, EAN-13 has 13.
const UPC_PATTERN = /^[0-9]{12,13}$/;

export const cleanUpc = (upc) => (upc || '').replace(/[\s-]/g, '');

/** A message for the UPC as answered, null when it can be sent. Editing an
 *  older release that never answered, `optional` lets it be saved as is. */
export function upcProblem(mode, upc, optional = false) {
    if (!mode) return optional ? null : 'Diz se já tens o código UPC deste lançamento.';
    if (mode !== 'existing') return null;
    const v = cleanUpc(upc);
    if (!v) return 'Insere o UPC que o lançamento já tem.';
    return UPC_PATTERN.test(v) ? null : 'O UPC tem 12 ou 13 algarismos.';
}

/** The fields to send. Não also clears a code typed before; no answer sends nothing. */
export function upcPayload(mode, upc) {
    if (mode === 'existing') return { upc: cleanUpc(upc), upc_pending: 0 };
    if (mode === 'izenu') return { upc: null, upc_pending: 1 };
    return {};
}

const inputCls = 'block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-amber-500 focus:ring-amber-500';

export default function UpcQuestion({ mode, upc, onModeChange, onUpcChange, showError, disabled, optional }) {
    const problem = showError ? upcProblem(mode, upc, optional) : null;
    return (
        <div>
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
                <span className="text-sm font-medium text-gray-700">Tens o código UPC deste lançamento?{!optional && <span className="text-red-500"> *</span>}</span>
                <div className={`inline-flex overflow-hidden rounded-full !border !border-solid ${problem && !mode ? 'border-red-400' : 'border-gray-300'}`} role="radiogroup">
                    {[['existing', 'Sim'], ['izenu', 'Não']].map(([value, label]) => (
                        <button key={value} type="button" role="radio" aria-checked={mode === value} disabled={disabled}
                            onClick={() => onModeChange(value)}
                            className={`px-4 py-1 text-xs font-medium ${mode === value ? 'bg-amber-500 !text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}>
                            {label}
                        </button>
                    ))}
                </div>
            </div>
            {mode === 'existing' && (
                <input aria-label="UPC" inputMode="numeric" maxLength={20} disabled={disabled}
                    className={`${inputCls} mt-2 !w-56 ${problem ? '!border-red-400' : ''}`}
                    value={upc} placeholder="0123456789012" onChange={(e) => onUpcChange(e.target.value)} />
            )}
            {mode === 'izenu' && <p className="mt-1 text-xs text-gray-500">Sem problema: a Izenu gera um UPC para este lançamento.</p>}
            {problem
                ? <p className="mt-1 text-xs text-red-600">{problem}</p>
                : !mode && <p className="mt-1 text-xs text-gray-500">O UPC é o código de barras do lançamento nas lojas.</p>}
        </div>
    );
}
